<template>
  <div v-if="critereRecherche" class="tableWithPerPageSelection">
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="echeanciersSelectionne"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-4 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeEcheances.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('listeEcheances.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permsCommandes.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="arrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="columns is-multiline is-vcentered">
      <div class='column is-6'>
        <date-picker :dates="critereRecherche.datePrevisionnelleFacturation"
          :time="timeParBond"
          customMove
          @recherche="recherche"/>
      </div>
      <div class="column is-6">
        <div class="is-pulled-right">
          <a @click="afficherEcheancesAnterieur()">
              <span v-if="indicateurAnt" class="has-text-primary mgr-10px lien">
                {{$t('listeEcheances.actions.echeancesAnterieurs', {
                number: totalEcheanciersAnt === 0 ? ' - ' : totalEcheanciersAnt
              })}}</span>
            <span v-else class="has-text-primary mgr-10px lien">
                {{$t('listeEcheances.actions.masquer')}}</span>
          </a>
        </div>
      </div>
      <suivi-mensuel class="column is-12"
                     ref="suiviMensuel"
                     :societe-id="societeActiveId"
                     :agences-ids="critereRecherche.agencesIds.length === 0
                     ? agencesSelectionnees.map((agence) => agence.agenceId)
                     : critereRecherche.agencesIds"
                     :periode="critereRecherche.datePrevisionnelleFacturation"
                     :parutionsIds = "critereRecherche.parutionsIds.map(el => el.id)">
      </suivi-mensuel>
    </div>
    <v-server-table
      url=""
      v-if="arrayRendering && mountedLoadingEnd"
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input='$refs[referenceTable].setLimit($event)' />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="echeanciers">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected" :disabled="props.row.facturationFaite"
                    :value="props.row"
                    @input="selectionEcheanciers()">
        </b-checkbox>
      </div>
      <div slot="code" slot-scope="props">
        <section class="is-flex is-justify-content-space-between">
          <router-link-blank
            :to="{ name: 'c.bodac.commandes',  params: {id: props.row.commandeId}}"
            :message="props.row.code"
            :class="{'text-access-no-permission': !checkPermissions(permsCommandes.lecture)}"
            class="lien is-inline">
          </router-link-blank>
          <send-facture-icon
            class="mgl-5px"
            :sendMail="props.row.factureParMail"/>
          <tag-list
                class="mgl-2 is-justify-content-flex-end"
                v-if="getListeTags(props.row)"
                :listes="getListeTags(props.row)"/>
        </section>
      </div>
      <div slot="agence" slot-scope="props">
          {{ getAgenceLibelle(props.row.agenceId) }}
      </div>
      <div slot="LignesCommandeLibelle" slot-scope="props">
        <p v-for="(type, index) in getProduit(props.row)" :key="index">
          {{ props.row.lignesCommandeRegroupementLibelle.length > 1 ? type : '- ' + type }}
        </p>
      </div>
      <div slot="LignesCommandeRegroupementLibelle" slot-scope="props">
        {{ getPatrimoine(props.row) }}
      </div>
      <div slot="CommercialPrenom" slot-scope="props">
        {{ props.row.commercialPrenom }} {{ props.row.commercialNom }}
      </div>
      <div slot="payeurNomCommercial" slot-scope="props">
        <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
                           params: { id: props.row.payeurId }}"
                           :message="props.row.payeurNomCommercial">
        </router-link-blank>
      </div>
      <div slot="dateDebut" slot-scope="props">
        {{props.row.dateDebut | formatDate}}
      </div>
      <div slot="dateFin" slot-scope="props">
        {{props.row.dateFin | formatDate}}
      </div>
      <div slot="montantHt" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="datePrevisionnelleFacturation" slot-scope="props">
        {{props.row.datePrevisionnelleFacturation | formatDate}}
      </div>
      <div slot="AnnonceursNomsCommerciaux" slot-scope="props">
        <router-link-blank
                v-for="(annonceur, index) in props.row.annonceursNomsCommerciauxIds"
               :key="index"
                v-bind="getRouteAnnonceur(annonceur)">
        </router-link-blank>
      </div>
      <div slot="commentaire" slot-scope="props">
        <b-tooltip position="is-left" v-if="props.row.commentaireFacturation">
          <b-icon type="is-primary" icon="information" size="small"></b-icon>
          <template v-slot:content>
            <p class="ellipsis max-width-715">
              {{ props.row.commentaireFacturation }}
            </p>
          </template>
        </b-tooltip>
      </div>
      <div slot="facturer" slot-scope="props"
          class="has-text-centered">
        <a @click="checkPermissions(permsFactures.maj) ? facturer(props.row) : showPopUp()">
          <button class="button is-primary"
                  :class="{'button-access-no-permission' : !checkPermissions(permsFactures.maj)}"
                  :disabled="props.row.facturationFaite">
            {{ $t('listeEcheances.actions.facturer')}}
          </button>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="isComponentFacturer"
             width="450px"
             has-modal-card
             class="modal">
      <app-facturer-echeances :echeances="echeanceAFacturer"
                              @reloadEcheanciers="reloadEcheancier"/>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-commande-a-facturer
          ref="filtreListeCommandeAFacturer"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter()"
          :disabled-filter-parution="!!$route.params.parutionId"/>
      </div>
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import inProgress from '@/services/general/inProgress';
import * as types from '@/store/modules/echeancier-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { COMMANDES, FACTURES } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import filtreListeCommandeAFacturer from '@/components/devisCommandes/filtreListeEcheancesCommandeAFacturer';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_BILL } from '@/configuration/commande/commandeConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import datePicker from '@/components/general/datePicker';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import * as devisConf from '@/configuration/devisConf';
import detailProduitEcheance from '@/components/commande/baf/detailProduitEcheance';
import formatIsoDate from '@/services/general/formatIsoDate';
import { columnsSplice } from '@/services/general/columns';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import suiviMensuel from '@/components/bodac/dcf/suiviMensuel/suiviMensuel';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import { REFERENCE_TABLE_LISTE_ECHEANCES } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { get as getParution } from '@/api/presse/parution';
import tagList from '@/components/general/tagList';
import moment from 'moment';
import sendFactureIcon from '@/components/devisCommandes/sendFactureIcon';
import facturerEcheances from './facturerEcheances';

const Echeanciers = createNamespacedHelpers('echeancier');
const Societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'EcheancesCommande',
  data() {
    return {
      isComponentFacturer: false,
      showFiltre: false,
      rechercheAvancee: false,
      echeanciersSelectionne: false,
      selectAllValue: false,
      echeanceAFacturer: [],
      permsCommandes: COMMANDES,
      permsFactures: FACTURES,
      unsubscribeValue: null,
      actions: [
        { action: ACTION_BILL, translation: 'editionCommande.actions.bill' },
      ],
      sens: devisConf.SENS_VENTE,
      arrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_LISTE_ECHEANCES,
      routeParution: null,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.echeancesAFacturerAA.key]);
      if (this.echeancesAFacturerAAIsActive) {
        this.critereRecherche.datePrevisionnelleFacturation = {
          dateDebut: (moment().startOf('year')).toDate(),
          dateFin: (moment().endOf('year')).toDate(),
        };
      }
      this.critereRecherche.agencesIds = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      if (this.$route.params.sens) this.sens = this.$route.params.sens;
      await updateCritereWithParametreInterne(this.critereRecherche);
      await this.filtreByRouteParutionId();
      this.setInformationPage(this.$t('pageGescom.commande.listeCommandeAFacturer'));
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  components: {
    appFacturerEcheances: facturerEcheances,
    filtreListeCommandeAFacturer,
    selecteurAction,
    TableItemsInView,
    routerLinkBlank,
    datePicker,
    suiviMensuel,
    tagList,
    tableFooterTotaux,
    parametrageTable,
    exportExcelButton,
    sendFactureIcon,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...Echeanciers.mapGetters({
      echeanciers: 'echeanciers',
      totalEcheanciers: 'totalEcheanciers',
      totalEcheanciersAnt: 'totalEcheanciersBeforeNow',
      critereRecherche: 'criteresRecherche',
      getOrderBy: 'orderBy',
      getIndicateurAnt: 'indicateurAnt',
      getDateSave: 'dateSave',
      lastDataFromLoad: 'lastDataFromLoad',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    orderBy: {
      get() {
        return this.getOrderBy;
      },
      set(value) {
        return this.setOrderBy(value);
      },
    },
    indicateurAnt: {
      get() {
        return this.getIndicateurAnt;
      },
      set(value) {
        return this.setIndicateurAnt(value);
      },
    },
    dateSave: {
      get() {
        return this.getDateSave;
      },
      set(value) {
        return this.setDateSave(value);
      },
    },
    iconSelectTotal() {
      if (this.selectAllValue) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    hasMultiProduitOrPatrimoine() {
      return this.echeanciers.some((echeance) => {
        return echeance.lignesCommandeRegroupementLibelle
          && echeance.lignesCommandeRegroupementLibelle.length > 1;
      });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          LignesCommandeRegroupementLibelle: this.$i18n.t('listeEcheances.table.patrimoine'),
          LignesCommandeLibelle: this.$i18n.t('listeEcheances.table.typeProduit'),
          code: this.$i18n.t('listeEcheances.table.number'),
          CommercialPrenom: this.$i18n.t('listeEcheances.table.commercial'),
          payeurNomCommercial: this.$i18n.t('listeEcheances.table.payeur'),
          AnnonceursNomsCommerciaux: this.$i18n.t('listeEcheances.table.annonceur'),
          dateDebut: this.$i18n.t('listeEcheances.table.dateDebut'),
          dateFin: this.$i18n.t('listeEcheances.table.dateFin'),
          montantHt: this.$i18n.t('listeEcheances.table.montantHt'),
          datePrevisionnelleFacturation: this.$i18n.t('listeEcheances.table.datePrev'),
          codeDossier: this.$i18n.t('listeEcheances.table.codeDossier'),
          agence: this.$i18n.t('listeEcheances.table.agence'),
          facturer: '',
          commentaire: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        childRow: this.hasMultiProduitOrPatrimoine ? detailProduitEcheance : null,
        rowClassCallback: ((row) => {
          if (!row.lignesCommandeRegroupementLibelle
            || (row.lignesCommandeRegroupementLibelle.length <= 1
              && this.hasMultiProduitOrPatrimoine && row.commentaireFacturation === null)) {
            return 'hideChildToggler disableChildRowClick';
          }
          return 'activeChildRowClick';
        }),
        sortable: ['code', 'LignesCommandeRegroupementLibelle', 'LignesCommandeLibelle', 'CommercialPrenom', 'AnnonceursNomsCommerciaux', 'payeurNomCommercial', 'dateDebut', 'dateFin', 'codeDossier', 'montantHt', 'datePrevisionnelleFacturation', 'agence'],
        columnsClasses: {
          selected: 'colonneSelected',
          AnnonceursNomsCommerciaux: 'ellipsis listeAnnonceurs',
        },
        requestFunction: (async (data) => {
          await this.filtreByRouteParutionId();
          if (data.orderBy === undefined) {
            data.orderBy = this.critereRecherche.orderBy;
            data.ascending = this.critereRecherche.ascending;
          }
          if (this.critereRecherche.agencesIds.length === 0) {
            this.critereRecherche.agencesIds = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.critereRecherche);
          if (data.query.groupeIds.length > 0) {
            data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
          }
          if (data.query.enseigneIds.length > 0) {
            data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => {
              return enseigne.id;
            });
          }
          if (data.query.payeursId.length > 0) {
            data.query.payeursId = data.query.payeursId.map((payeur) => {
              return payeur.id;
            });
          }
          if (data.query.annonceursId.length > 0) {
            data.query.annonceursId = data.query.annonceursId.map((annonceur) => {
              return annonceur.id;
            });
          }
          if (data.query.categorieVente.length > 0) {
            data.query.categorieVente = data.query.categorieVente.map((categorie) => {
              return categorie.code;
            });
          }
          if (this.modulePresseActive && data.query.regleFacturationIds.length > 0) {
            data.query.regleFacturationIds = data.query.regleFacturationIds.map(el => el.id);
          }
          if (this.modulePresseActive && data.query.parutionsIds.length > 0) {
            data.query.parutionsIds = data.query.parutionsIds.map(el => el.id);
          }
          data.query.datePrevisionnelleFacturation.dateDebut = formatIsoDate(
            data.query.datePrevisionnelleFacturation.dateDebut,
          );
          data.query.datePrevisionnelleFacturation.dateFin = formatIsoDate(
            data.query.datePrevisionnelleFacturation.dateFin,
          );
          if (data.query?.dateCampagne) {
            data.query.dateCampagne.dateDebut = formatIsoDate(data.query.dateCampagne.dateDebut);
            data.query.dateCampagne.dateFin = formatIsoDate(data.query.dateCampagne.dateFin);
          }
          if (data.query?.dateCommande) {
            data.query.dateCommande.dateDebut = formatIsoDate(data.query.dateCommande.dateDebut);
            data.query.dateCommande.dateFin = formatIsoDate(data.query.dateCommande.dateFin);
          }
          data.query.societeId = this.societeActiveId;
          if (this.echeancesAFacturerAAIsActive) {
            data.query.withEcheanceNegative = false;
          }
          data.query.sens = this.sens;
          this.$refs.suiviMensuel.reload();
          return this.actionsLoadEcheancier(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.echeanciers,
            count: this.totalEcheanciers,
          };
        }),
      };
    },
    columns() {
      const columns = ['selected', 'code', 'LignesCommandeRegroupementLibelle', 'LignesCommandeLibelle', 'CommercialPrenom', 'AnnonceursNomsCommerciaux', 'payeurNomCommercial', 'dateDebut', 'dateFin', 'codeDossier', 'montantHt', 'datePrevisionnelleFacturation', 'commentaire', 'agence', 'facturer'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    targetTotal() {
      return ['montantHt'];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'societeId', 'datePrevisionnelleFacturation', 'aFacturer', 'bonAFacturer', 'facturationFaite', 'etats', 'datesPrevisionnellesFacturationFacturee',
        'datesPrevisionnellesFacturationNonFacturee', 'factureParEmail', 'dateCampagne', 'dateCommande', 'estSigne', 'estSigneElectroniquement', 'estIndexable'];
      if (this.societeActive.agences.length === 1) banCritereKey.push('agencesIds');
      let nombreCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (this.critereRecherche.dateCampagne.dateDebut
         || this.critereRecherche.dateCampagne.dateFin) {
        nombreCritere += 1;
      }
      if (this.critereRecherche.dateCommande.dateDebut
         || this.critereRecherche.dateCommande.dateFin) {
        nombreCritere += 1;
      }
      nombreCritere += this.critereRecherche.estSigne !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.estSigneElectroniquement !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.estIndexable !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.facturationFaite !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.factureParEmail !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key);
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'commande',
        typeExport: 'VYPAFacturer',
        filtres: this.lastDataFromLoad,
      };
    },
    echeancesAFacturerAAIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.echeancesAFacturerAA.key);
    },
    timeParBond() {
      if (this.echeancesAFacturerAAIsActive) return 'years';
      return 'months';
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Echeanciers.mapMutations({
      setCritereRecherche: types.SET_CRITERE,
      setOrderBy: types.SET_ORDERBY,
      setIndicateurAnt: types.SET_INDICATEUR,
      setDateSave: types.SET_DATE_SAVE,
    }),
    ...Echeanciers.mapActions({
      actionsLoadEcheancier: 'loadEcheancier',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    getRouteAnnonceur(nomId) {
      return {
        to: {
          name: 'c.bodac.clients/contacts-client',
          params: {
            id: nomId.split('#')[1],
          },
        },
        message: nomId.split('#')[0],
      };
    },
    getListeTags(row) {
      if (!row?.tags || row.tags.length === 0) return null;
      return row?.tags?.map(t => t.tag) ?? [];
    },
    updateAgenceAndRecherche() {
      this.critereRecherche.agencesIds = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.recherche();
    },
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    getProduit(commandeBaf) {
      if (commandeBaf.lignesCommandeLibelle.length === 0) return [];
      if (commandeBaf.lignesCommandeRegroupementLibelle.length > 1) {
        return [this.$i18n.t('listeEcheances.table.multiProduit')];
      }
      return commandeBaf.lignesCommandeLibelle;
    },
    getPatrimoine(commandeBaf) {
      if (commandeBaf.lignesCommandeRegroupementLibelle.length === 0) return '';
      if (commandeBaf.lignesCommandeRegroupementLibelle.length > 1) {
        return this.$i18n.t('listeEcheances.table.multiPatrimoine');
      }
      return commandeBaf.lignesCommandeRegroupementLibelle[0];
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommandeAFacturer.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    selectionEcheanciers() {
      this.echeanciersSelectionne = this.echeanciers.filter((el) => {
        return el.selected;
      }).length > 0;
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.echeanciers.forEach((el) => {
        if (!el.facturationFaite) el.selected = this.selectAllValue;
      });
      this.echeanciersSelectionne = this.selectAllValue;
    },
    facturer(data) {
      this.isComponentFacturer = true;
      this.echeanceAFacturer = [data];
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    getInfo() {
      this.inProgress();
    },
    afficherEcheancesAnterieur() {
      this.indicateurAnt = !this.indicateurAnt;
      const data = {
        query: {},
        indicateurAnt: this.indicateurAnt,
      };
      if (!this.indicateurAnt) {
        this.critereRecherche.orderBy = 'datePrevisionnelleFacturation';
        this.critereRecherche.ascending = 0;
        this.dateSave.dateDebut = this.critereRecherche.datePrevisionnelleFacturation.dateDebut;
        this.dateSave.dateFin = this.critereRecherche.datePrevisionnelleFacturation.dateFin;
        this.critereRecherche.datePrevisionnelleFacturation.dateDebut = null;
        this.critereRecherche.datePrevisionnelleFacturation.dateFin = new Date();
      } else {
        this.critereRecherche.ascending = 1;
        this.critereRecherche.datePrevisionnelleFacturation.dateDebut = this.dateSave.dateDebut;
        this.critereRecherche.datePrevisionnelleFacturation.dateFin = this.dateSave.dateFin;
      }
      data.query = this.critereRecherche;
      this.recherche();
    },
    facturerEcheancesSelectionnes() {
      this.isComponentFacturer = true;
      this.echeanceAFacturer = this.echeanciers.filter((el) => { return el.selected; });
    },
    editDate() {
      if (this.critereRecherche.datePrevisionnelleFacturation.dateDebut !== this.dateSave.dateDebut
        && this.critereRecherche.datePrevisionnelleFacturation.dateFin !== this.dateSave.dateFin) {
        this.recherche();
      }
    },
    reloadEcheancier() {
      this.echeanceAFacturer = [];
      this.recherche();
      this.isComponentFacturer = false;
    },
    handleAction(action) {
      if (action === ACTION_BILL) {
        if (this.checkPermissions(this.permsFactures.maj)) {
          this.facturerEcheancesSelectionnes();
        } else this.showPopUp();
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommandeAFacturer.initializeFiltre();
      await this.$refs.filtreListeCommandeAFacturer.viderCritere();
      this.$refs.filtreListeCommandeAFacturer.appliquerCritere();
      this.showFiltre = false;
    },
    async filtreByRouteParutionId() {
      if (this.modulePresseActive && this.$route.params.parutionId) {
        if (!this.routeParution) {
          this.routeParution = (await getParution(this.$route.params.parutionId)).data.result;
          const dateParu = new Date(this.routeParution.dateParution);
          this.critereRecherche.datePrevisionnelleFacturation = {
            dateDebut: new Date(dateParu.getFullYear(), dateParu.getMonth(), 1),
            dateFin: new Date(dateParu.getFullYear(), dateParu.getMonth() + 1, 0),
          };
        }
        this.critereRecherche.parutionsIds = [this.routeParution];
      }
    },
  },
};

</script>

<style scoped>

</style>
